import React, { PureComponent, Fragment, createRef } from 'react'
import { Button, Grid, Paper } from '@material-ui/core'
import { Add as AddIcon } from '@material-ui/icons'
import { EditableReactSelect } from '../components/common/EditableComponents'
import { connect } from 'react-redux'

// utils
import { switchApp, changeShop } from '../actions/auth'
import { updateEmployee } from '../actions/employee'
import { logoConstants, appTargets } from '../utils/constants'

// action
import { startLoading, stopLoading } from '../actions/loading'
import { getCompanies, getCompanyFeatures } from '../actions/company'
import { addShop, getShopList } from '../actions/shop'
import { openErrorMessage } from '../actions/message'
import { getOrganizations, getOrganizationViews } from '../actions/organization'

// components

import Heading from '../components/common/Heading'
import NavHeader from '../components/layout/NavHeader'
import ContainerWithTitle from './HOC/ContainerWithTitle'
import AddShopModal from '../components/Modal/AddShopModal'
import { getSession } from '../utils/api'
//import qs from 'query-string';
import config from '../config/config'
import Footer from './Footer'
import { redirectToBlazeInsights } from '../actions/insights'
import { initHubSpot } from '../utils/crm'
import { getApiUrl } from '../utils/common'
import {
  getCompanySelectOption,
  getFirstCompanyShop,
  getInitialOrganizationSelection,
  getOrganizationSelectOption,
} from '../utils/switchAppSelection'

const apiUrl = getApiUrl()
const isDevEnvironment = config.apiFB

class SwitchApp extends PureComponent {
  state = {
    shopId: '',
    appName: '',
    selectedOrganization: '',
    selectedCompany: '',
    companiesOptionsTemp: [],
    companyFeatures: {},
    organizationViewsList: [],
    selectedOrgView: {},
    selectedCompanyView: {},
  }

  addShopModal = createRef()

  switchApp = (appName, shopId) => (e) => {
    this.props.dispatch(startLoading())

    this.props.dispatch(switchApp({ appName, shopId })).then((newSession) => {
      window.location.href = `${newSession.redirectURL}/login?token=${newSession.accessToken}`
      this.props.dispatch(stopLoading())
    })
  }

  onShopChange = (shopId, appName) => {
    this.setState({ shopId })

    this.props.dispatch(startLoading())
    if (appName === 'Grow') {
      this.props.dispatch(changeShop(shopId, 'Sales')).then((session) => {
        //const switchAppWithAppName = this.switchApp(appName, shopId)
        //switchAppWithAppName();
        //window.location.reload();
      })
    } else {
      this.props.dispatch(changeShop(shopId)).then((session) => {
        //const switchAppWithAppName = this.switchApp(appName, shopId)
        //switchAppWithAppName();
        //window.location.reload();
      })
    }
  }

  //Filter shops with the organization and company selected
  filterShops = (shops) => {
    const { organizationsList = {} } = this.props.organizationReducer
    const { companyList = {} } = this.props.companyReducer
    let companyIds = (companyList.length && companyList.map((company) => company.id)) || []
    const itemOrganization =
      organizationsList.length &&
      organizationsList.find((e) => e.id === this.state.selectedOrganization.value)
    if (itemOrganization !== undefined) {
      companyIds = itemOrganization.companyIds
    }
    //If employee doesn't belong to any organization, use its companyId
    if (organizationsList.length === 0) {
      if (!Array.isArray(companyIds)) {
        companyIds = []
      }
      let { employee } = getSession()
      companyIds.push(employee.companyId)
    }

    let filteredShops =
      shops &&
      shops.filter(
        (shop) =>
          (companyIds && companyIds.length === 0) ||
          (!this.state.selectedCompany && companyIds && companyIds.includes(shop.companyId)) ||
          (this.state.selectedCompany && this.state.selectedCompany.value === shop.companyId),
      )
    return filteredShops
  }

  filterOutShops = (shops) => {
    let targets = {}
    shops = shops || []
    shops = this.filterShops(shops)
    shops
      .filter((shop) => shop.active)
      .forEach((shop) => {
        let appTarget = shop.appTarget
        targets[appTarget] = targets[appTarget] || []
        targets[appTarget].push(shop)
      })

    return targets
  }

  addShop = (data) => {
    let { employee } = getSession()

    this.props
      .dispatch(addShop(data))
      .then((shop) => {
        employee.shops.push(shop.id)
        this.props
          .dispatch(updateEmployee(employee, shop))
          .then((res) => {
            this.props.dispatch(getShopList())
            this.addShopModal.current.handleClose()
          })
          .catch((err) => {
            console.log(err)
          })
      })
      .catch((error) => {
        console.log(error)
      })
  }

  onError = (message) => this.props.dispatch(openErrorMessage(message))

  openAddShopModal = (app) => (e) => {
    this.addShopModal.current.handleClickOpen(app)
  }

  async callFromDatabase() {
    const organizationList = await this.props.dispatch(getOrganizations())
    if (organizationList.length > 0) {
      await this.props.dispatch(getShopList())
      await this.props.dispatch(getCompanies())
    }

    const organizationViewsList = await this.props.dispatch(getOrganizationViews())

    const companyFeaturesList = await this.props.dispatch(getCompanyFeatures())

    const session = getSession()
    const initialOrganizationSelection = getInitialOrganizationSelection(
      organizationViewsList,
      session,
    )
    this.setState((_, props) => ({
      ...initialOrganizationSelection,
      shopId: (session && session.assignedShop && session.assignedShop.id) || '',
      companyFeatures: companyFeaturesList,
      organizationViewsList: organizationViewsList,
    }))
  }

  async componentDidMount() {
    //const searchParams = window.location.search
    //const queryParams = qs.parse(searchParams);

    /* if(queryParams.return) {
            window.localStorage.setItem('returnUrl', queryParams.return);
        } else {
            window.localStorage.removeItem('returnUrl');
        } */
    const { dispatch, authReducer } = this.props
    const { session = {} } = authReducer
    const { employee } = session
    initHubSpot(dispatch, employee)
    this.callFromDatabase()
  }

  componentWillReceiveProps(nextProps) {
    const { session = {} } = nextProps.authReducer
    if (
      this.props.authReducer.session &&
      this.props.authReducer.session.accessToken !== session.accessToken
    ) {
      this.setState({
        shopId: (session && session.assignedShop && session.assignedShop.id) || '',
      })
    }
  }

  goToShop = (obj) => {
    //const user = getSession();
    let host = ''
    //let { session = {} } = this.props.authReducer;
    //let { assignedShop } = session;

    host = appTargets[obj.appTarget]

    let data = {
      appName: obj.appTarget,
      shopId: obj.id,
    }

    if (obj.appTarget === 'Grow') {
      data = {
        ...data,
        growAppType: 'Sales',
      }
    }
    this.props
      .dispatch(switchApp(data))
      .then((res) => {
        let token = res.accessToken

        if (obj.appTarget === 'Grow') {
          token = decodeURIComponent(res.accessToken)
        }

        let ref = `${host}/login?token=${token}&shop=${obj.id}`
        if (isDevEnvironment) {
          ref = `${host}/login?token=${token}&shop=${obj.id}&apiUrl=${apiUrl}`
        }
        window.location.href = ref
      })
      .catch((err) => {
        console.log(err)
      })
  }

  goToInsightsDashboards = (obj) => {
    let host = appTargets[obj.appTarget]
    let data = {
      appName: obj.appTarget,
      shopId: obj.id,
    }

    this.props
      .dispatch(switchApp(data))
      .then((res) => {
        let token = res.accessToken
        let insightsUrl = `${host}/insights?token=${token}&shop=${obj.id}`
        let loginUrl = `${host}/login?token=${token}&shop=${
          obj.id
        }&urlToRedirect=${encodeURIComponent(insightsUrl)}`

        if (isDevEnvironment) {
          insightsUrl = `${host}/insights?token=${token}&shop=${obj.id}&apiUrl=${apiUrl}`
          loginUrl = `${host}/login?token=${token}&shop=${
            obj.id
          }&apiUrl=${apiUrl}&urlToRedirect=${encodeURIComponent(insightsUrl)}`
        }

        // Redirect to the login page with a redirectUrl parameter
        window.location.href = loginUrl
      })
      .catch((err) => {
        console.log(err)
      })
  }

  goToDispatchApp = () => {
    if (!this.state.shopId) {
      this.props.dispatch(openErrorMessage('Select a location before opening Dispatch'))
      return
    }

    let host = ''

    let obj = {
      appTarget: 'Dispatch',
      id: this.state.shopId,
    }

    host = appTargets[obj.appTarget]

    let data = {
      appName: obj.appTarget,
      shopId: obj.id,
    }

    this.props
      .dispatch(switchApp(data))
      .then((res) => {
        let token = res.accessToken
        window.location.href = `${host}/login?token=${token}&shop=${obj.id}`
      })
      .catch((err) => {
        console.log(err)
      })
  }

  goToInsightsApp = async () => {
    let url = await this.props.dispatch(redirectToBlazeInsights())
    if (url) {
      window.open(url, '_blank')
    }
  }

  goToGrowOperations = (obj) => {
    //const user = getSession();
    let host = ''
    //let { session = {} } = this.props.authReducer;
    //let { assignedShop } = session;

    host = config.growOperationsUrl

    this.props
      .dispatch(switchApp({ appName: obj.appTarget, shopId: obj.id, growAppType: 'Operations' }))
      .then((res) => {
        //console.log(obj.appTarget , obj.id , "object passed ")
        window.location.href = `${host}/login?token=${res.accessToken}&shop=${obj.id}`
      })
      .catch((err) => {
        console.log(err)
      })
  }

  selectFirstCompanyShop = (firstCompanyOption) => {
    const selectedCompanyView = this.state.selectedCompanyView || {}
    const firstShop = getFirstCompanyShop(selectedCompanyView)

    if (!firstShop) {
      this.setState({ shopId: '' })
      return
    }

    this.onShopChange(firstShop.id, firstShop.appTarget)
  }

  onChangeOrganizations = (organization) => {
    const selectedOrganization = organization || ''
    // Filter companies based on my  selected organization

    const { organizationViewsMap = {} } = this.props.organizationReducer

    const orgView = organizationViewsMap[selectedOrganization.value] || {}

    const orgCompanies = orgView.companies || []
    const filteredCompanyList = orgCompanies.map(getCompanySelectOption)
    const firstCompanyOption = filteredCompanyList.length > 0 ? filteredCompanyList[0] : ''

    this.setState(
      {
        selectedOrganization: selectedOrganization,
        selectedCompany: firstCompanyOption,
        companiesOptionsTemp: filteredCompanyList,
        selectedOrgView: orgView,
        selectedCompanyView: orgCompanies.length > 0 ? orgCompanies[0] : {},
      },
      () => {
        if (firstCompanyOption != '') {
          // eslint-disable-line
          this.selectFirstCompanyShop(firstCompanyOption)
        }
      },
    )
  }

  getOrgOptions = () => {
    const { organizationsList = [], organizationViewsList = [] } = this.props.organizationReducer
    const organizationOptions =
      (organizationViewsList.length &&
        organizationViewsList.map((organization) => {
          return {
            ...getOrganizationSelectOption(organization),
          }
        })) ||
      []

    return organizationOptions
  }

  selectInitialOrganization = () => {
    const { companyList = {} } = this.props.companyReducer
    const { shopsList = {} } = this.props.shopReducer
    const { organizationViewsList = [] } = this.props.organizationReducer
    const shopsListValues = shopsList.values || []

    let selectedOrganization = this.state.selectedOrganization || ''
    const organizationOptions = this.getOrgOptions()

    if (
      selectedOrganization == '' &&
      organizationOptions.length > 0 &&
      companyList.length > 0 &&
      shopsListValues.length > 0
    ) {
      // eslint-disable-line
      const session = getSession()
      const initialOrganizationSelection = getInitialOrganizationSelection(
        organizationViewsList,
        session,
      )
      this.setState(initialOrganizationSelection, () => {
        const hasAssignedShop = session && session.assignedShop && session.assignedShop.id
        if (!hasAssignedShop && initialOrganizationSelection.selectedCompany != '') {
          // eslint-disable-line
          this.selectFirstCompanyShop(initialOrganizationSelection.selectedCompany)
        }
      })
    }
  }

  onChangeCompanies = (company) => {
    const selectedCompany = company || ''

    const selectedOrgView = this.state.selectedOrgView || {}
    const selectedOrgCompanies = selectedOrgView.companies || []
    const companyView = selectedOrgCompanies.find((e) => e.id === selectedCompany.value)

    this.setState(
      { selectedCompany: selectedCompany, selectedCompanyView: companyView || {} },
      () => {
        this.selectFirstCompanyShop(selectedCompany)
      },
    )
  }

  render() {
    const { authReducer } = this.props
    const { session = {} } = authReducer
    const { employee = {}, assignedShop = {}, employeeShops = [] } = session
    let { appAccessList = [] } = employee || {}
    const shopsListValues =
      (this.state.selectedCompanyView && this.state.selectedCompanyView.shops) || []
    const { organizationViewsList = [] } = this.props.organizationReducer
    //const { companyList = {} } = this.props.companyReducer;
    const shopListToFilter = this.state.selectedOrganization == '' ? employeeShops : shopsListValues // eslint-disable-line
    const filteredOutShops = this.filterOutShops(shopListToFilter)
    const { maxShop = '', availableApps = [] } = this.state.companyFeatures || {}
    appAccessList =
      availableApps.length > 0
        ? availableApps
        : Object.keys(filteredOutShops).filter((app) => app !== 'AuthenticationApp')
    let selectedOrganization = this.state.selectedOrganization || ''
    const selectedCompany = this.state.selectedCompany || []

    const organizationOptions = this.getOrgOptions()

    this.selectInitialOrganization()

    var filteredShopEntries = Object.entries(filteredOutShops)
    var count = 0
    if (filteredShopEntries.length > 0) {
      filteredShopEntries.forEach(([key, value]) => {
        count += value.length
      })
    }
    return (
      <Grid container className="shopsLayout pb-4">
        <NavHeader
          shops={shopsListValues}
          shopId={this.state.shopId}
          appName={this.state.appName}
          assignedShop={assignedShop}
          dispatch={this.props.dispatch}
        />
        <Grid item lg={12} className="full-width">
          <Heading className="font-normal vertical-middle total-shops">
            Total Locations ({count}/{maxShop})
          </Heading>
        </Grid>
        {organizationViewsList.length > 0 ? (
          <Grid container>
            <Grid container item xs={6} className="full-width">
              <Grid item xs={5}>
                <h2 className="font-normal">Organizations</h2>
                <EditableReactSelect
                  clearable={false}
                  multi={false}
                  valueToRender={selectedOrganization.label}
                  editMode={true}
                  value={selectedOrganization}
                  onChange={this.onChangeOrganizations}
                  type="text"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  options={organizationOptions}
                />
              </Grid>
              <Grid item xs={2} />
              <Grid item xs={5}>
                <h2 className="font-normal">Companies</h2>
                <EditableReactSelect
                  placeholder={'AAA'}
                  multi={false}
                  clearable={false}
                  valueToRender={selectedCompany.label}
                  editMode={true}
                  value={selectedCompany}
                  onChange={this.onChangeCompanies}
                  type="text"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  options={this.state.companiesOptionsTemp}
                />
              </Grid>
            </Grid>
          </Grid>
        ) : null}

        {appAccessList.length &&
          appAccessList
            .filter(
              (app) =>
                app !== 'AuthenticationApp' &&
                app !== 'Dispatch' &&
                app !== 'Insights' &&
                app !== 'Worker',
            )
            .sort((a, b) => {
              const order = ['Retail', 'Distribution', 'Grow']
              return (
                (order.indexOf(a) === -1 ? 999 : order.indexOf(a)) -
                (order.indexOf(b) === -1 ? 999 : order.indexOf(b))
              )
            })
            .map((app, index) => {
              const shops = filteredOutShops[app] || []
              return (
                <Grid key={index} item lg={12} className="margin-top-medium remove-margin">
                  <Heading className="font-normal vertical-middle font-title">
                    <img
                      style={{
                        width: 40,
                        height: 40,
                        marginRight: 15,
                      }}
                      src={logoConstants[app]}
                      alt=""
                    />
                    {app !== 'Grow'
                      ? app === 'Distribution'
                        ? 'Distro '
                        : `${app} `
                      : 'Cultivation '}
                    Locations
                  </Heading>
                  <div container className="full-width">
                    {shops.map((shop, index) => {
                      return (
                        <div key={index} className="main-menus-listing">
                          <Paper
                            data-cy={'btn-store-shop'}
                            elevation={8}
                            className={`center-aligned-child menu-inner-list child-column column-child full-width ${
                              this.state.shopId === shop.id ? 'selectedShopBg' : ''
                            }`}
                            onClick={() => this.onShopChange(shop.id, app)}
                          >
                            <div className="icon-sec">
                              <img
                                style={{
                                  width: 75,
                                  height: 75,
                                }}
                                alt=""
                                src={shop.logo ? shop.logo.mediumURL : logoConstants[app]}
                              />
                            </div>
                            <span>{shop.name}</span>
                          </Paper>
                          {this.state.shopId === shop.id && shop.appTarget === 'Grow' ? (
                            <Fragment>
                              <Button
                                data-cy="btn-shop-operation"
                                variant="raised"
                                className={shop.appTarget}
                                style={{ marginTop: 20 }}
                                onClick={this.goToGrowOperations.bind(this, shop)}
                              >
                                Operations
                              </Button>
                              <Button
                                data-cy="btn-shop-sales"
                                variant="raised"
                                className={shop.appTarget}
                                style={{ marginTop: 20, marginLeft: 4 }}
                                onClick={this.goToShop.bind(this, shop)}
                              >
                                Sales
                              </Button>
                            </Fragment>
                          ) : null}
                          {this.state.shopId === shop.id && shop.appTarget !== 'Grow' ? (
                            <Button
                              data-cy="btn-shop-location"
                              variant="raised"
                              className={shop.appTarget}
                              style={{ marginTop: 20 }}
                              onClick={() => this.goToShop(shop)}
                            >
                              {' '}
                              Go to Location{' '}
                            </Button>
                          ) : null}
                        </div>
                      )
                    })}
                    {employeeShops.length < maxShop ? (
                      <div key={index} className="main-menus-listing">
                        <Paper
                          elevation={8}
                          className="center-aligned-child menu-inner-list child-column column-child full-width"
                          onClick={this.openAddShopModal(app)}
                        >
                          <div className="icon-sec">
                            <AddIcon style={{ fontSize: 40 }} className="margin-bottom-small" />
                          </div>
                          <span>Add Location</span>
                        </Paper>
                      </div>
                    ) : null}
                  </div>
                </Grid>
              )
            })}
        {availableApps &&
          availableApps.length > 0 &&
          (availableApps.indexOf('Dispatch') >= 0 || availableApps.indexOf('Insights') >= 0) && (
            <Grid item lg={12} className="full-width">
              <Heading className="font-normal vertical-middle font-title">
                Company-wide Apps
              </Heading>
              <div container className="full-width">
                {availableApps &&
                  availableApps.length > 0 &&
                  availableApps.indexOf('Dispatch') >= 0 && (
                    <div className="main-menus-listing">
                      <Paper
                        data-cy={'btn-store-dispatch'}
                        elevation={8}
                        className={`center-aligned-child menu-inner-list child-column column-child full-width`}
                        onClick={this.goToDispatchApp.bind(this)}
                      >
                        <div className="icon-sec">
                          <img
                            style={{
                              width: 75,
                              height: 75,
                            }}
                            alt=""
                            src={logoConstants['Dispatch']}
                          />
                        </div>
                        <span>{'Dispatch'}</span>
                      </Paper>
                      <Button
                        data-cy="btn-dispatch-location"
                        variant="raised"
                        className={'Dispatch'}
                        style={{ marginTop: 20 }}
                        onClick={this.goToDispatchApp.bind(this)}
                      >
                        Go to Dispatch
                      </Button>
                    </div>
                  )}
                {shopListToFilter
                  .filter((shop) => shop.id === this.state.shopId && shop.appTarget === 'Retail')
                  .map((shop, index) => (
                    <div key={index} className="main-menus-listing">
                      <Paper
                        data-cy={'btn-store-insights'}
                        elevation={8}
                        className={`center-aligned-child menu-inner-list child-column column-child full-width`}
                        onClick={() => this.goToInsightsDashboards(shop)}
                      >
                        <div className="icon-sec">
                          <img
                            style={{
                              width: 75,
                              height: 75,
                            }}
                            alt=""
                            src={logoConstants['Insights']}
                          />
                        </div>
                        <span>{'Insights'}</span>
                      </Paper>
                      <Button
                        data-cy="btn-insights-location"
                        variant="raised"
                        className={'Insights'}
                        style={{ marginTop: 20 }}
                        onClick={() => this.goToInsightsDashboards(shop)}
                      >
                        Go to Insights
                      </Button>
                    </div>
                  ))}
              </div>
            </Grid>
          )}

        <Grid item lg={12} className="full-width switch-app-footer pt-4">
          <Footer />
        </Grid>
        <AddShopModal ref={this.addShopModal} addShop={this.addShop} onError={this.onError} />
      </Grid>
    )
  }
}

export default connect((state) => ({
  authReducer: state.authReducer,
  dispatch: state.dispatch,
  shopReducer: state.shopReducer,
  organizationReducer: state.organizationReducer,
  companyReducer: state.companyReducer,
}))(ContainerWithTitle(SwitchApp, 'Switch App'))



// WEBPACK FOOTER //
// ./src/containers/SwitchApp.js